import React, { FC } from 'react';
import './Result.scss';
import { IResultProps } from './IResultProps';
import { IFoRResult } from '../../../../Models/IResult';
import { getLanguage } from '../../../../utils/searchHelpers';
//import { handleLinkClick} from '../../../../utils/recordPageClickHandler';
import { Card, Paragraph, Heading, Tag } from '@udir-design/react/beta';
import { getContentType, getLastModified, getIntroTitleHtml, getFoRTeaser } from '../../../../utils/resultHelpers';
import { DisplayFormat } from '../../../../Models/DisplayFormat';
import { getCurrentDisplayFormat } from '../../../../utils/generalHelpers';


const Result: FC<IResultProps> = (props) => {
    let { result } = props
    let language_attr = getLanguage(result);
    const isMobile = getCurrentDisplayFormat() === DisplayFormat.Mobile;
    const displayTitle = result.udirtitle ? result.udirtitle : result.title;
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        //const queryText = props.queryText || '';
        //handleLinkClick(result.Url, result, queryText);
    };
    //let resultInfo = [  result.rapportnivaa.replaceAll(";",", "), 
                        //result.rapportutgiver.replaceAll(";",", "), //rapportaar fjernes
                        //result.rapportutgiver.replaceAll(";",", ")].filter(Boolean).join(" - ");
    //const hasResultInfo = resultInfo.trim().length > 0;
    let nivaa        = result.rapportnivaa.replaceAll(";",", ");
    const hasNivaa   = nivaa.trim().length > 0;
    let utgiver      = result.rapportutgiver.replaceAll(";",", ")
    const hasUtgiver = utgiver.trim().length > 0;
    
    return (
            <Card  className="ResultLinkCard" key={`resultDisplay-${props.idx}`}>
                
                <Card.Block className="LinkCard__container">
                    <div className="LinkCard">
                        <Paragraph className="LinkCard__headerandsubtitle" data-size="sm">
                            <span className="subtitle-top title">{getContentType(result)}</span>
                            <span className="subtitle-top date">{getLastModified(result)}</span>
                        </Paragraph>

                        {getIntroTitleHtml(result) && (
                            <Paragraph className="LinkCard__introtitle" data-size="sm">
                                {getIntroTitleHtml(result)}
                            </Paragraph>
                        )}
                        
                        <Heading level={2}>
                            <a className="cardtitle" href={result.Url} rel="noopener noreferrer">
                                {displayTitle}
                            </a>
                        </Heading>
                        
                        {getFoRTeaser(result)}

                        {(hasNivaa || hasUtgiver) && (
                            <div className='TagGroup metadata' data-size={isMobile ? 'sm' : 'md'}>
                                {hasNivaa && (
                                    <Tag data-color="accent">
                                        {nivaa}
                                    </Tag>
                                )}
                                {hasUtgiver && (
                                    <Tag data-color="accent">
                                        {utgiver}
                                    </Tag>
                                )}
                            </div>
                        )}
                    </div>
                </Card.Block>
                
                
            </Card>
        )
    
    return (
        <div className="ResultPane" key={`resultDisplay-${props.idx}`}>
            {getIntroTitle(result, language_attr)}
            <a className="resultLink" href={result.Url} rel="noopener" onClick={handleClick}>
                <h2 key={`resultHeader-1`} className="no-margin-top" {...language_attr}>{displayTitle}</h2>
            </a>
            {getTeaserText(result, language_attr)}
            <div className="resultSubheader">
                {getMetadata(result)}
            </div>
        </div>
    )
}

// Teaser now provided by utils/getFoRTeaser

const getIntroTitle = (result: IFoRResult, language_attr) => {
    const introHtml = getIntroTitleHtml(result);
    return introHtml ? [<p className="introtitle" key="introtitle" {...language_attr} dangerouslySetInnerHTML={{ __html: introHtml }} />] : [];
}

const getTeaserText = (result: IFoRResult, language_attr) => {
    let teaserElement: React.ReactElement[] = [];
    const hasDescription = result.description !== null && result.description !== undefined
        && result.description !== "" && result.description !== "&nbsp;" && result.description !== "&nbsp;\n&nbsp;";
    const qs = window.location.search;
    const isEmptySearch = qs === "" || qs === '?query=' || qs === '?query=*' || qs.indexOf('query=*') !== -1 || qs.indexOf('query=') === -1;
    if (hasDescription) {
        // Bruk highlightet description ved aktivt søk, ellers ren description
        const descriptionHtml = (!isEmptySearch && result.hhdescription) ? result.hhdescription : result.description;
        teaserElement.push(<p key="teaser-1" {...language_attr} dangerouslySetInnerHTML={{__html: descriptionHtml}} />);
    } else if (!isEmptySearch && result.hhsummary) {
        // Ingen description: fall tilbake til dynamisk hhsummary, men kun ved aktivt søk
        teaserElement.push(<p key="teaser-2" {...language_attr} dangerouslySetInnerHTML={{__html: result.hhsummary}} />);
    }
    return teaserElement;
}

const getMetadata = (result: IFoRResult) => {
    let metadataElements: React.ReactElement[] = [];
    let hasDate:boolean = false;
    if(result.innholdstype) {
        metadataElements.push(<span className="capitalLetters" key="resultData-1">{result.innholdstype}</span>);
        metadataElements.push(<span className="resultDivider" key="resultDivider-1"/>);
    }
    if(result.datoendret) {
        if(result.innholdstype && result.innholdstype !== "Tema"){ 
            const dateFormatted = getLastModified(result);
            if (dateFormatted) {
                hasDate = true;
                metadataElements.push(<span key="resultData-2" className="bold">Sist endret: </span>);
                metadataElements.push(<span key="resultData-3">{dateFormatted}</span>);
            }
        }
    }
    if(result.rapportnivaa || result.rapportutgiver || result.rapportaar) {
        if(hasDate) {
            metadataElements.push(<span className="resultDivider" key="resultDivider-2"/>);
        }
        let resultInfo = [result.rapportnivaa.replaceAll(";",", "), 
                          result.rapportutgiver.replaceAll(";",", "), 
                          result.rapportaar.replaceAll(";",", ")].filter(Boolean).join(" - ");
        
        metadataElements.push(<span key="resultData-4">{resultInfo}</span>)
    }

    // Removing last element if it is a resultDivider 
    if (metadataElements.length > 0) {
        const lastElement = metadataElements[metadataElements.length - 1];
        if (lastElement && lastElement.props && lastElement.props.className === "resultDivider") {
          metadataElements.pop();
        }
    }

    return metadataElements;
}

export default Result;

